import { render, staticRenderFns } from "./addPrinter.vue?vue&type=template&id=6642c241&scoped=true"
import script from "./addPrinter.vue?vue&type=script&lang=js"
export * from "./addPrinter.vue?vue&type=script&lang=js"
import style0 from "./addPrinter.vue?vue&type=style&index=0&id=6642c241&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6642c241",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/c-webhlzfq_workbench-web_en_test/orca-ac-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6642c241')) {
      api.createRecord('6642c241', component.options)
    } else {
      api.reload('6642c241', component.options)
    }
    module.hot.accept("./addPrinter.vue?vue&type=template&id=6642c241&scoped=true", function () {
      api.rerender('6642c241', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/dialog/addPrinter.vue"
export default component.exports